import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import validateForm from '../../helpers/validateform';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-first-rest-password',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './first-rest-password.component.html',
  styleUrl: './first-rest-password.component.css'
})
export class FirstRestPasswordComponent {
  resetPwd!: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';
  lang: any;
  termsAgreed: any;
  privecy: any;
  loginId: any;
  password: any;
  isExpired: boolean = false;
  
  constructor(private formBuilder: FormBuilder, private router: Router, private translate: TranslateService, private user: UserService, private auth: AuthService, private en: EncryptionService) { }
      
    ngOnInit(): void {
      this.translate.addLangs(['en', 'jp']);

      if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        this.lang = localStorage.getItem('site_lang') ?? 'jp';
        localStorage.setItem('site_lang', this.lang);
        this.translate.use(this.lang);
      }

      this.loginId = history.state['loginId'];
      this.password = history.state['password'];
      this.isExpired = history.state['isExpired'] === true;

      this.resetPwd = this.formBuilder.group({
          loginId: [this.loginId, Validators.required],
          oldPassword: [this.password, Validators.required],
          newPassword: ['', Validators.required],
          retypeNewPassword: ['', [Validators.required]]
        },
        { validator: this.passwordMatchValidator }
      );
  }
  
  passwordMatchValidator(control: AbstractControl): null {
    const newPass = control.get('newPassword');
    const retypePass = control.get('retypeNewPassword');

    if (!newPass || !retypePass) return null;

    const password = newPass.value;
    const confirm = retypePass.value;

    const alphaNumRegex = /^(?=.*[A-Za-z])(?=.*\d).*$/;

    let newPassErrors = newPass.errors || {};
    let retypeErrors = retypePass.errors || {};

    /* -----------------------------------
      NEW PASSWORD VALIDATION
    ------------------------------------ */

    // If required error exists → skip custom validation
    if (newPassErrors['required']) {
      newPass.setErrors({ required: true });
      return null;
    }

    // MIN LENGTH
    if (!password || (password.length < 6 || password.length > 50)) {
      newPassErrors['minlength'] = true;
    } else {
      delete newPassErrors['minlength'];
    }

    // ALPHANUMERIC
    if (!alphaNumRegex.test(password)) {
      newPassErrors['alphanumeric'] = true;
    } else {
      delete newPassErrors['alphanumeric'];
    }

    // Apply updated errors
    newPass.setErrors(Object.keys(newPassErrors).length ? newPassErrors : null);

    /* -----------------------------------
      RETYPE PASSWORD VALIDATION
    ------------------------------------ */

    // Skip match validation if required
    if (retypeErrors['required']) {
      retypePass.setErrors({ required: true });
      return null;
    }

    // MATCH CHECK
    if (password && confirm && password.toLowerCase() !== confirm.toLowerCase()) {
      retypeErrors['mismatch'] = true;
    } else {
      delete retypeErrors['mismatch'];
    }

    // Apply updated errors
    retypePass.setErrors(Object.keys(retypeErrors).length ? retypeErrors : null);

    return null;
  }
      get f() { return this.resetPwd.controls; }
    
      resetPwdFrm() {
        // console.log(this.resetPwd.value.password);
        if (this.resetPwd.invalid) {
              validateForm.validateAllFormFields(this.resetPwd);
              alert(this.translate.instant('PleaseFillFormCorrectly'));     
              return;
        }
        
        const payLoad = {
          "loginId": this.loginId,
          "password": this.en.encryptUsingAES256(this.resetPwd.value.oldPassword),
          "newPassword": this.en.encryptUsingAES256(this.resetPwd.value.newPassword),
          "retypeNewPassword": this.en.encryptUsingAES256(this.resetPwd.value.retypeNewPassword)
        }
        // console.log(payLoad);
        // return;
        const apiCall = this.isExpired
          ? this.user.changePasswordExpired(payLoad)
          : this.user.restInitPassword(payLoad);
        apiCall
          .subscribe({
            next: (res: any) => {
              if (res.status) {
                this.successMessage = res.message;
                this.errorMessage = '';
                // alert(res.message)
                // this.router.navigate(['login']);
                const payLoad = {
                  "loginID": this.loginId,
                  "password": this.en.encryptUsingAES256(this.resetPwd.value.newPassword)
                }
                this.auth.login(payLoad, this.lang).subscribe({
                  next: (res:any) => {
                    // alert(res.message);
                    if (res.status) {
                      this.auth.storeToken(res.data.token);
                      // パスワード有効期限日を保存
                      if (res.data?.passwordExpiryDate) {
                        const d = new Date(res.data.passwordExpiryDate);
                        const formatted = `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
                        this.auth.storePasswordExpiryDate(formatted);
                      } else {
                        this.auth.storePasswordExpiryDate(null);
                      }
                      this.errorMessage = '';
                      this.successMessage = res.message;
                      
                      // Get user profile data
                      this.user.getUserProfile().subscribe({
                        next: (res: any) => {
                          if (res.status) {              
                            this.auth.storeCode(res.data.userCode);
                            this.auth.storeName(res.data.userName);
                            this.auth.storeLoginId(res.data.loginId);
                            this.auth.storeRole(res.data.userRole);
                            this.auth.storeEmail(res.data.email2);
                            this.auth.storeType(res.data.userType);
                            this.auth.storeAdminLevel(res.data.adminLevel);
                            this.auth.storeReadWrite(res.data.readWrite);                            
                            this.auth.storeCompanyName(res.data.companyName);
                            if (res.data.noticeEmail) {
                              this.termsAgreed = 'yes';
                            } else {
                              this.termsAgreed = 'no';
                            }
                            
                            if (res.data.privacy) {
                              this.privecy = 'yes';
                            } else {
                              this.privecy = 'no';
                            }
                            this.auth.storeNotice(this.termsAgreed);
                            this.auth.storePrivecy(this.privecy);
                            // console.log(res.data.userRole);
                            

                            if (this.privecy == "yes") {                  
                              if (res.data.userRole == 'Client') {
                                this.router.navigate(['client-associatelist'], { state: { consent: this.termsAgreed } });
                              } else if(res.data.userRole == 'Staff') {  
                                this.router.navigate(['home'], { state: { consent: this.termsAgreed } });
                              }
                              // else if (res.data.userRole == 'Admin') {
                              //   this.router.navigate(['admin-home']);
                              //   return;
                              // } else if (res.data.userRole == 'Rep') {
                              //   // this.router.navigate(['administrator-menu']);
                              //   this.router.navigate(['representative-home']);
                              //   return;
                                // }
                              if (res.data.userRole == 'Admin' || res.data.userRole == 'Rep') {                   
                              if (res.data.userType == 'C') {
                                if (res.data.userRole == 'Admin') {
                                  this.router.navigate(['admin-home']);
                                } else {
                                  this.router.navigate(['representative-home']);
                                }
                              } else if (res.data.userType == 'B' || res.data.userType == 'D') {
                                this.router.navigate(['client-associatelist']);
                              } else if (res.data.userType == 'A') {
                                this.router.navigate(['asc-report']);
                              }
                              return;
                            } else if (res.data.userRole == 'Manager') {
                                // this.router.navigate(['administrator-menu']);
                                this.router.navigate(['manager-home']);
                                return;
                              }
                            }
                            else {
                              this.router.navigate(['privacy']);
                            }
                            // console.log(this.termsAgreed);
                            // this.auth.storeConsent(this.termsAgreed);
                          } else {
                            // console.log(res.message);
                            alert(res.message);
                            
                          }
                        },
                        error: (err: any) => {
                          // alert(err.error.message);
                          // alert(err?.error.message);
                          this.successMessage = '';
                          this.errorMessage = err?.error.message;
                        }
                      });

                    } else {
                      alert(res.message);                     
                      this.router.navigate(['login']);
                    }
                  },
                  error: (err) => {        
                    alert(err.error.message);        
                    this.successMessage = '';
                    this.errorMessage = err?.error.message;
                  }
                });
                return
              } else {
                this.errorMessage = res.message;
                this.successMessage = '';
                alert(res.message)
              } 
            },
            error: (err: any) => {
              this.errorMessage = err.message;
              this.successMessage = '';
            }
        })
        
      }
}
